import {
    LayoutDashboard,
    BarChart2,
    Receipt,
    Users,
    User,
    UserCircle,
    Calculator,
    ClipboardList,
    FileDown,
    FolderOpen,
    Video,
    Building,
    ShieldCheck,
} from "lucide-react";

export const ownerSidebarData = [
    {
        section: "Reports",
        links: [
            {
                id: 1,
                externalLink: false,
                title: "Dashboard",
                path: "/user/dashboard",
                icon: LayoutDashboard,
            },
            {
                id: 2,
                externalLink: false,
                title: "Financials",
                path: "/user/financials",
                icon: BarChart2,
            },
            {
                id: 4,
                externalLink: false,
                title: "Deposit Summary",
                path: "/user/depositsummary",
                icon: Receipt,
            },
            {
                id: 5,
                externalLink: false,
                title: "Clients",
                path: "/user/clients?type=policy",
                icon: Users,
            },
        ],
    },
    {
        section: "Account",
        links: [
            {
                id: 11,
                externalLink: false,
                title: "Profile",
                path: "/user/profile",
                icon: User,
            },
            {
                id: 13,
                externalLink: false,
                title: "Security",
                path: "/user/security",
                icon: ShieldCheck,
            },
            {
                id: 12,
                externalLink: false,
                title: "Advisors",
                path: "/user/advisors",
                icon: UserCircle,
            },
        ],
    },
    {
        section: "Enrollments",
        links: [
            {
                id: 5,
                externalLink: false,
                title: "Quotes",
                path: "/user/quotes",
                icon: Calculator,
            },
            {
                id: 6,
                externalLink: false,
                title: "Digital Enrollments",
                path: "/user/enrollments",
                icon: ClipboardList,
            },
            {
                id: 7,
                externalLink: false,
                title: "Enrollment PDF Forms",
                path: "/user/enrollment-fillable",
                icon: FileDown,
            },
        ],
    },
    {
        section: "Marketing",
        links: [
            {
                id: 8,
                externalLink: false,
                title: "Documents",
                path: "/user/marketing",
                icon: FolderOpen,
            },
            {
                id: 9,
                externalLink: false,
                title: "Videos",
                path: "/user/videos",
                icon: Video,
            },
            // {
            //     id: 10,
            //     externalLink: true,
            //     title: "Advisor Answers - FAQ",
            //     path: "https://www.nationalhealthclaim.com/advisor-answers/",
            // },
        ],
    },

];

export const advisorSidebarData = [
    {
        section: "Account",
        links: [
            {
                id: 1,
                externalLink: false,
                title: "Profile",
                path: "/user/profile",
                icon: User,
            },
            {
                id: 2,
                externalLink: false,
                title: "Clients",
                path: "/user/companies",
                icon: Building,
            },
        ],
    },
    {
        section: "Enrollments",
        links: [
            {
                id: 5,
                externalLink: false,
                title: "Quotes",
                path: "/user/quotes",
                icon: Calculator,
            },
            {
                id: 6,
                externalLink: false,
                title: "Digital Enrollments",
                path: "/user/enrollments",
                icon: ClipboardList,
            },
            {
                id: 7,
                externalLink: false,
                title: "Enrollment PDF Forms",
                path: "/user/enrollment-fillable",
                icon: FileDown,
            },
        ],
    },
    {
        section: "Marketing",
        links: [
            {
                id: 8,
                externalLink: false,
                title: "Documents",
                path: "/user/marketing",
                icon: FolderOpen,
            },
            {
                id: 9,
                externalLink: false,
                title: "Videos",
                path: "/user/videos",
                icon: Video,
            },
            // {
            //     id: 10,
            //     externalLink: true,
            //     title: "Advisor Answers - FAQ",
            //     path: "https://www.nationalhealthclaim.com/advisor-answers/",
            // },
        ],
    },
];
